(function(W) {
  if (W.Interpolation) {
    return;
  }
  return W.Interpolation = require('interpolation.coffee');
})(Wistia);
